import {
  jb_text_area_css_default
} from "./chunk.RO3JILRI.js";
import {
  e
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.LJHCRQCZ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  FormElement
} from "./chunk.TQSPBGH7.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n,
  r
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-text-area/jb-text-area.ts
var JbTextArea = class extends Initiable(FormElement(i)) {
  constructor() {
    super(...arguments);
    this.rows = 9;
    this._currentLength = 0;
  }
  _handleInput(e2) {
    this.value = e2.target.value;
    if (this.maxLength) {
      this._currentLength = this.value.length;
    }
  }
  _handleInputChange(e2) {
    this.value = e2.target.value;
  }
  render() {
    return b`
      <div
        class=${e({
      optional: this.requiredText === "" || !this.requiredText,
      error: this.showError || !!this.errorText,
      disabled: !!this.disabled
    })}
      >
        <label for=${this.name}>${this.label}${this.requiredText ? "*" : ""} </label>
        <textarea
          rows=${this.rows}
          cols="104"
          placeholder="${this.placeholder}"
          style="resize:vertical"
          ?disabled=${this.disabled}
          .maxLength=${this.maxLength ?? A}
          .name=${this.name}
          .id=${this.name}
          ?required=${!!this.requiredText}
          .value=${typeof this.value === "string" ? this.value : ""}
          @change=${this._handleInputChange}
          @input=${this._handleInput}
          aria-errormessage=${this.showError || !!this.errorText ? `${this.name}_error` : A}
          aria-invalid="${this.showError || !!this.errorText ? "true" : "false"}"
        ></textarea>
        ${this.maxLength ? b`<div class="counter">
                <span>${this.maxLengthText ?? A}</span><span>${this._currentLength} / ${this.maxLength}</span>
              </div>` : A}
        <div id="${this.name}_error">
          ${this.showError || this.errorText ? b`<p>
                  ${this.showError ? b`<span>${this.requiredText}</span>` : A}
                  ${this.errorText ? b`<span>${this.errorText}</span>` : A}
                </p>` : A}
        </div>
      </div>
    `;
  }
};
JbTextArea.styles = [reset_css_default, jb_text_area_css_default];
__decorateClass([
  n({ type: Number })
], JbTextArea.prototype, "maxLength", 2);
__decorateClass([
  n()
], JbTextArea.prototype, "maxLengthText", 2);
__decorateClass([
  n()
], JbTextArea.prototype, "placeholder", 2);
__decorateClass([
  n({ type: Number })
], JbTextArea.prototype, "rows", 2);
__decorateClass([
  r()
], JbTextArea.prototype, "_currentLength", 2);
JbTextArea = __decorateClass([
  customElement("jb-text-area")
], JbTextArea);

export {
  JbTextArea
};
